const educationDegrees = {
    highschool: 'High School',
    associate: 'Associate Degree',
    bachelor: "Bachelor's Degree",
    master: "Master's Degree",
    doctorate: 'Doctorate / PhD',
};

const yearsOfExperience = {
    0: '0',
    '1-3': '1-3',
    '4-6': '4-6',
    '7-10': '7-10',
    '11-15': '11-15',
    '16+': '16+',
};

const races = {
    caucasian: 'Caucasian (Non-Hispanic)',
    black: 'Black',
    hispanic: 'Hispanic',
    asian: 'Asian or Pacific Islander',
    native: 'Native American or Alaska Native',
    mixed: 'Mixed',
    other: 'Other',
    undisclosed: 'Prefer not to say',
};

const genders = {
    male: 'Male',
    female: 'Female',
    undisclosed: 'Prefer not to say',
    custom: 'Custom',
};

const statuses = {
    complete: 'complete',
    incomplete: 'incomplete',
    rejected: 'rejected',
    applied: 'applied',
    archived: 'archived',
    inactive: 'inactive',
};

const constants = Object.freeze({
    EDUCATION_DEGREES: Object.freeze(educationDegrees),
    YEARS_OF_EXPERIENCE: Object.freeze(yearsOfExperience),
    RACES: Object.freeze(races),
    GENDERS: Object.freeze(genders),
    STATUSES: Object.freeze(statuses),
});

export default constants;
